var _excluded = ["label", "disabled", "type", "error", "value"],
    _excluded2 = ["className", "classNameInput", "classNameLabel", "small"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import cx from "classnames";
import "./input.scss";

var Input = function Input(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? "" : _ref$error,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      props = _objectWithoutProperties(_ref, _excluded);

  var className = props.className,
      classNameInput = props.classNameInput,
      classNameLabel = props.classNameLabel,
      small = props.small,
      otherInputProps = _objectWithoutProperties(props, _excluded2);

  var isErrorString = typeof error === "string";
  return /*#__PURE__*/React.createElement("div", {
    className: cx("cntInput", error && "cntInput__error", className && className)
  }, label && /*#__PURE__*/React.createElement("label", {
    className: cx("cntInput_label", classNameLabel && classNameLabel)
  }, label), /*#__PURE__*/React.createElement("input", _extends({}, otherInputProps, {
    value: value || "",
    className: cx("cntInput_field", classNameInput && classNameInput),
    type: type,
    disabled: disabled
  })), isErrorString && /*#__PURE__*/React.createElement("p", {
    className: cx("cntInput_error")
  }, error));
};

export default Input;